import { render, staticRenderFns } from "./WfConsumerCorpModal.vue?vue&type=template&id=746c33d2&scoped=true&"
import script from "./WfConsumerCorpModal.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpModal.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerCorpModal.vue?vue&type=style&index=0&id=746c33d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c33d2",
  null
  
)

export default component.exports